export const COLORS = {
	Primary: "#106fe6",
	Secondary: "#00A4E3",
	Default: "#66C1D7",
	Grey: "#BBC4C2",
	LightGrey: "#F3F4F6",
	MediumGrey: "#99a19f",
	DarkGrey: "#4f4f4f",
	White: "#ffffff",
	Black: "#000000",
	NearBlack: "#171717",
	Danger: "#ff4d4f",
	Warning: "#faad14",
	Success: "#52c41a",
	LightGreen: "#86EFAC",
	StrongGreen: "#4ADE80",
	SkeletonGrey: "#bebebe33",
	LightGrey2: "#f7f7f7",
};

export default COLORS;
